module.exports = __webpack_public_path__ + "static/img/ewm.7108d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ewm.png
// module id = PNRf
// module chunks = 1